import AboutModal from './AboutModal.json';
import Buttons from './Buttons.json';
import CineDialog from './CineDialog.json';
import Common from './Common.json';
import ContextMenu from './ContextMenu.json';
import DataOverlay from './DataOverlay.json';
import DataSourceConfiguration from './DataSourceConfiguration.json';
import DatePicker from './DatePicker.json';
import ErrorBoundary from './ErrorBoundary.json';
import Header from './Header.json';
import HotkeysValidators from './HotkeysValidators.json';
import Local from './Local.json';
import MeasurementTable from './MeasurementTable.json';
import Modes from './Modes.json';
import Orientation from './Orientation.json';
import SegmentationTable from './SegmentationTable.json';
import SegmentationTableAppearanceSettings from './SegmentationTable.AppearanceSettings.json';
import SegmentationTableHeaderCollapsed from './SegmentationTable.HeaderCollapsed.json';
import SidePanel from './SidePanel.json';
import StudyBrowser from './StudyBrowser.json';
import StudyBrowserTracking from './StudyBrowserTracking.json';
import StudyItem from './StudyItem.json';
import StudyList from './StudyList.json';
import ToolTip from './ToolTip.json';
import TooltipClipboard from './TooltipClipboard.json';
import ThumbnailTracked from './ThumbnailTracked.json';
import TrackedCornerstoneViewport from './TrackedCornerstoneViewport.json';
import UserPreferencesModal from './UserPreferencesModal.json';
import ViewportDownloadForm from './ViewportDownloadForm.json';
import Messages from './Messages.json';
import WindowLevelActionMenu from './WindowLevelActionMenu.json';
import InvestigationalUseDialog from './InvestigationalUseDialog.json';
import MobileWarningDialog from './MobileWarningDialog.json';
import Modals from './Modals.json';
import Keys from './Keys.json';
import ToolbarLayoutSelector from './ToolbarLayoutSelector.json';

export default {
  'pl-PL': {
    AboutModal,
    Buttons,
    CineDialog,
    Common,
    ContextMenu,
    DataOverlay,
    DataSourceConfiguration,
    DatePicker,
    ErrorBoundary,
    Header,
    HotkeysValidators,
    Local,
    MeasurementTable,
    Modes,
    Orientation,
    SegmentationTable,
    'SegmentationTable.AppearanceSettings': SegmentationTableAppearanceSettings,
    'SegmentationTable.HeaderCollapsed': SegmentationTableHeaderCollapsed,
    SidePanel,
    StudyBrowser,
    StudyBrowserTracking,
    StudyItem,
    StudyList,
    ToolTip,
    TooltipClipboard,
    ThumbnailTracked,
    TrackedCornerstoneViewport,
    UserPreferencesModal,
    ViewportDownloadForm,
    Messages,
    WindowLevelActionMenu,
    InvestigationalUseDialog,
    MobileWarningDialog,
    Modals,
    Keys,
    ToolbarLayoutSelector,
  },
};
